import {
  Alert,
  Box,
  Button,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material'
import clsx from 'clsx'
import { useStyles } from '../../styles'
import { useMemo, useState } from 'react'
import { ReactComponent as RocketLaunch } from '../../../../assets/icons/rocket-launch.svg'
import { ReactComponent as Clock } from '../../../../assets/icons/clock.svg'
import { ReactComponent as Calendar } from '../../../../assets/icons/calendar-blank.svg'
import useTranslations from '../../../../i18n/useTranslations'
import DatePicker from '../../../../ui/components/datePicker'
import useIsMobile from '../../../../hooks/useIsMobile'
import Select from '../../../../ui/components/select'
import { useUserContext } from '../../../../auth/UserProvider'
import useAvailableHours from '../../../../context/ShippingSend/Step1Origin/useAvailableHours'
import { format } from 'date-fns'
import { checkIsNotIncluded } from '../../../../libs/datePicker'
import PropTypes from 'prop-types'
import { CalendarBlank } from 'phosphor-react'

const ChoosePickup = ({
  filesToUpload,
  manifestFiles,
  hasPickUp,
  onClose,
  centerSelected,
}) => {
  const classes = useStyles()
  const t = useTranslations()
  const isMobile = useIsMobile()
  const [selected, setSelected] = useState(0)

  const [pickupDay, setPickupDay] = useState()

  const [pickupHour, setPickupHour] = useState('none')

  const { centres } = useUserContext()

  const getPickUpCodes = () => {
    let postalCodes = []
    centres?.forEach(function (item) {
      if (!postalCodes.includes(item?.shippingAddress.postalCode)) {
        postalCodes.push(item?.shippingAddress.postalCode)
      }
    })
    return postalCodes?.length ? postalCodes[0] : []
  }

  const availableHours = useAvailableHours(
    getPickUpCodes(),
    format(new Date(), 'dd-MM-yyyy'),
  )

  const enabledCalendarDays = useMemo(
    () =>
      !Array.isArray(availableHours.data)
        ? []
        : availableHours.data.map(pickupDay =>
            format(pickupDay[0].minDate, 'yyyy-MM-dd'),
          ),
    [availableHours.data],
  )

  const generateHourArray = (selectedDate, data) => {
    if (!selectedDate || !data) return []
    const date = new Date(selectedDate)
    const selectedDateStr = date.toISOString().slice(0, 10)

    const dayData = data.find(day => {
      const minDateStr = new Date(day[0].minDate).toISOString().slice(0, 10)
      return minDateStr === selectedDateStr
    })

    if (!dayData) return []

    const hourArray = dayData.map(slot => {
      const startTime = new Date(slot.minDate).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
      const endTime = new Date(slot.maxDate).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })
      return `${startTime}-${endTime}`
    })

    return hourArray
  }

  const getHours = () => {
    const today = new Date()
    const currentDayOfWeek = today.getDay()
    const currentHour = today.getHours()
    const currentMinute = today.getMinutes()
    const timeZones = hasPickUp.fixedPickupsAdresses[0].timeZones

    const formatTwoDigits = (num) => num.toString().padStart(2, '0');

    for (let i = 0; i < 14; i++) {
      const nextDay = (currentDayOfWeek + i) % 7;
    
      if (timeZones[nextDay].length > 0) {
        const minHour = timeZones[nextDay][0]?.fromHour;
        const maxHour = timeZones[nextDay][timeZones[nextDay].length - 1]?.toHour;
    
        const maxHourNumeric = parseInt(maxHour.split(':')[0]);
        const maxMinuteNumeric = parseInt(maxHour.split(':')[1]);
        
        if (i === 0 && (currentHour > maxHourNumeric || (currentHour === maxHourNumeric && currentMinute >= maxMinuteNumeric))) {
          continue;
        }
    
        const pickupDate = new Date();
        pickupDate.setDate(pickupDate.getDate() + i);
    
        const day = formatTwoDigits(pickupDate.getDate());
        const month = formatTwoDigits(pickupDate.getMonth() + 1);
        const year = pickupDate.getFullYear();
    
        return {
          dayMonth: `${day}/${month}/${year}`,
          minHour: minHour,
          maxHour: maxHour,
        };
      }
    }
      
    
  }

  const onClickImport = async () => {
    const date = {
      has_pickup_asap: selected === 0 && !hasPickUp,
      is_fixed_pickup: hasPickUp ? true : false,
      comments:
        selected === 0 && hasPickUp
          ? 'Recogida fija'
          : selected === 0
          ? 'Recogida propuesta'
          : selected === 1
          ? 'Fecha y hora'
          : 'Más tarde',
      time:
        selected === 1
          ? [
              {
                max_hourminute: pickupHour.split('-')[1],
                min_hourminute: pickupHour.split('-')[0],
              },
            ]
          : selected === 0 && hasPickUp
          ? [
              {
                max_hourminute: getHours().maxHour,
                min_hourminute: getHours().minHour,
              },
            ]
          : [],
    }

    if (selected !== 2 && !hasPickUp)
      date['date'] = pickupDay ?? enabledCalendarDays[0]
    else if (selected === 0 && hasPickUp)
      date['date'] = getHours().dayMonth.split('/').reverse().join('-')
    await manifestFiles.mutate({
      file: filesToUpload[0],
      initialPickupDetails: date,
      clientCenterCode: centerSelected?.id,
    })
  }

  const renderContent = () => {
    switch (selected) {
      case 0:
        return hasPickUp ? (
          <Box className={classes.pickUpContent}>
            <Alert
              severity="success"
              icon={<CalendarBlank />}
              className={classes.alert}
            >
              <Typography variant="h3medium">
                {t('shipping-recording:pickup-date', {
                  date: getHours().dayMonth,
                  minHour: getHours().minHour,
                  maxHour: getHours().maxHour,
                })}
              </Typography>
            </Alert>
            <Alert severity="warning" className={classes.alert}>
              <Typography variant="h3medium">
                {t('shipping-send-message:schedule-may-change')}
              </Typography>
            </Alert>
          </Box>
        ) : (
          <Box className={classes.pickUpContent}>
            <Alert
              className={classes.alert}
              severity="warning"
              iconAlignment="top"
            >
              <b>{t('shipping-recording:asap-warning')}</b>
              <p>{t('shipping-recording:asap-warning-2')}</p>
            </Alert>
            <Alert
              className={classes.alert}
              severity="info"
              iconAlignment="top"
            >
              {t('shipping-recording:asap-info')}
            </Alert>
          </Box>
        )
      case 1:
        return (
          <Box className={classes.pickUpContent}>
            <Box className={classes.paragraphText}>
              <DatePicker
                error={false}
                name="pickupDay"
                label={t('noun:pick-up-date')}
                placeholder={t('placeholder:date')}
                autoOk={true}
                autocomplete="off"
                renderInput={params => (
                  <TextField
                    onKeyDown={evt => evt.preventDefault()}
                    {...params}
                  />
                )}
                onChange={date => {
                  setPickupDay(format(date, 'yyyy-MM-dd'))
                  setPickupHour('none')
                }}
                minDate={new Date()}
                className={
                  isMobile
                    ? clsx('input-full', classes.marginInput)
                    : clsx('input-small', classes.marginInput)
                }
                value={pickupDay ?? enabledCalendarDays[0]}
                shouldDisableDate={date =>
                  checkIsNotIncluded(date, enabledCalendarDays)
                }
              />
              <Select
                label={t('noun:timetable')}
                labelId="pick-up-timetable"
                name="pickupSchedule"
                className={
                  isMobile
                    ? clsx('input-full', classes.marginInput)
                    : clsx('input-small', classes.marginInput)
                }
                value={pickupHour}
                defaultValue="none"
                onChange={event => {
                  setPickupHour(event.target.value)
                }}
              >
                {generateHourArray(
                  pickupDay ?? enabledCalendarDays[0],
                  availableHours?.data,
                ).map(e => {
                  return (
                    <MenuItem key={e} value={e}>
                      <em>{e}</em>
                    </MenuItem>
                  )
                })}
                <MenuItem disabled value="none">
                  <em>
                    {t('shipping-send-form:origin:pickup:choose-schedule')}
                  </em>
                </MenuItem>
              </Select>
            </Box>
            <Alert
              className={classes.alert}
              severity="info"
              iconAlignment="top"
            >
              {t('shipping-recording:choose-info')}
            </Alert>
          </Box>
        )
      case 2:
        return (
          <Box className={classes.pickUpContent}>
            <Alert
              className={classes.alert}
              severity="warning"
              iconAlignment="top"
            >
              <b>{t('shipping-recording:later-warning')}</b>
            </Alert>
            <Alert
              severity="info"
              className={classes.alert}
              iconAlignment="top"
            >
              {t('shipping-recording:later-info')}
            </Alert>
          </Box>
        )
      default:
        return null
    }
  }

  return (
    <Box component="section" sx={classes.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', classes.title)}
      >
        {t('shipping-send-form:title:pick-up-date')}
      </Typography>

      <Box sx={classes.buttonsWrapper}>
        <Button
          size="small"
          startIcon={<RocketLaunch weight="regular" />}
          variant={selected === 0 ? 'contained' : 'outlined'}
          onClick={() => {
            setSelected(0)
          }}
        >
          {hasPickUp
            ? t('message:fixedPickup')
            : t('action:as-soon-as-possible')}
        </Button>
        {!hasPickUp ? (
          <Button
            size="small"
            startIcon={<Clock weight="regular" />}
            variant={selected === 1 ? 'contained' : 'outlined'}
            onClick={() => {
              setSelected(1)
            }}
          >
            {t('action:want-choose-day-and-time')}
          </Button>
        ) : null}
        {/* <Button
          size="small"
          startIcon={<Calendar weight="regular" />}
          variant={selected === 2 ? 'contained' : 'outlined'}
          onClick={() => {
            setSelected(2)
          }}
        >
          {t('action:request-later')}
        </Button> */}
      </Box>

      {renderContent()}

      <Box className={classes.buttonsGroup}>
        <Button
          variant="outlined"
          className={classes.marginInput}
          size={'small'}
          onClick={onClose}
        >
          {t('action:cancel')}
        </Button>
        <Button
          size={'small'}
          disabled={
            (selected === 1 && pickupHour === 'none') || manifestFiles.isLoading
          }
          onClick={onClickImport}
        >
          {t('action:import-file')}
        </Button>
      </Box>
    </Box>
  )
}

ChoosePickup.propTypes = {
  manifestFiles: PropTypes.func,
  filesToUpload: PropTypes.array,
}

export default ChoosePickup
